var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrowRightDouble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.2,21c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l7.4-7.4L3.7,4.7c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l8,8 c0.4,0.4,0.4,1,0,1.4l-8.1,8.1C4.7,20.9,4.5,21,4.2,21z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.7,21c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l7.4-7.4l-7.3-7.3c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l8,8 c0.4,0.4,0.4,1,0,1.4l-8.1,8.1C12.2,20.9,12,21,11.7,21z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRightDouble);
export default __webpack_public_path__ + "static/media/icon-arrow-right-double.cf59ecda5b608923ef68c438181ad3cf.svg";
export { ForwardRef as ReactComponent };